import * as React from 'react';
import styled from 'styled-components';
const HeaderWrapper = styled.div`
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 10px 0;
    display: flex;
    justify-content: center;
        & .inbox {
            text-align: center;
        }
        & .logo {
            width: 326px;
            height: 72px;
            background-image: url('/images/TokyoChuo.svg');
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
`
const Header = () => {
  return (
    <HeaderWrapper >
      <i className="logo"></i>
    </HeaderWrapper>
  );
};

export default Header;
